import React from 'react';
import { Card } from 'react-bootstrap';
import { Button, Col, Row } from 'react-bootstrap';

import ComplementoAerolineasBaseResumen from './ComplementoAerolineasBaseResumen';
import ComplementoAerolineasCargosResumen from './ComplementoAerolineasCargosResumen';

const ComplementoAerolineasResumen = ({ data = {}, onEdit, onDelete }) => {
  const handleOnDelete = () => {
    onDelete('Aerolineas');
  }

  const handleOnEdit = () => {
    onEdit('Aerolineas', data);
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">
          Aerolineas, Versión { data.Version }
        </Card.Subtitle>

        <ComplementoAerolineasBaseResumen data={ data } />

        <ComplementoAerolineasCargosResumen data={ data } />

        <Row className="pt-3">
          <Col>
            <Button variant="danger"
              className="mr-3"
              onClick={ handleOnDelete }
            >
              Quitar
            </Button>

            <Button variant="secondary"
              onClick={ handleOnEdit }
            >
              Editar
            </Button>
          </Col>
        </Row>

      </Card.Body>
    </Card>
  )
}

export default ComplementoAerolineasResumen;
